import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout/Layout';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { ForgotPassword } from './pages/ForgotPassword';
import { ResetPassword } from './pages/ResetPassword';
import { VerifyEmail } from './pages/VerifyEmail';
import { Dashboard } from './pages/Dashboard';
import { ProspectPipeline } from './pages/ProspectPipeline';
import { TeamOverview } from './pages/TeamOverview';
import { RoleManagement } from './pages/RoleManagement';
import { ApprovalManagement } from './pages/ApprovalManagement';
import { TenantManagement } from './pages/TenantManagement';
import { FastStartPlanner } from './pages/FastStartPlanner';
import { Profile } from './pages/Profile';
import { SocialMediaCalendar } from './pages/SocialMediaCalendar';
import { PlaybookLibrary } from './pages/PlaybookLibrary';
import { AppointmentsPage } from './pages/AppointmentsPage';
import { TimeBlockingPage } from './pages/TimeBlockingPage';
import { LeaderboardPage } from './pages/LeaderboardPage';
import { AIAssistantPage } from './pages/AIAssistantPage';
import { Toaster } from './components/ui/sonner';
import '@/App.css';

function AppRoutes() {
  const { user } = useAuth();

  return (
    <Routes>
      <Route 
        path="/login" 
        element={user ? <Navigate to="/" replace /> : <Login />} 
      />
      <Route 
        path="/register" 
        element={user ? <Navigate to="/" replace /> : <Register />} 
      />
      <Route 
        path="/forgot-password" 
        element={user ? <Navigate to="/" replace /> : <ForgotPassword />} 
      />
      <Route 
        path="/reset-password" 
        element={user ? <Navigate to="/" replace /> : <ResetPassword />} 
      />
      <Route 
        path="/verify-email" 
        element={<VerifyEmail />} 
      />
      
      <Route element={
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      }>
        <Route path="/" element={<Dashboard />} />
        <Route path="/pipeline" element={<ProspectPipeline />} />
        <Route path="/appointments" element={<AppointmentsPage />} />
        <Route path="/time-blocking" element={<TimeBlockingPage />} />
        <Route path="/leaderboard" element={<LeaderboardPage />} />
        <Route path="/ai-assistant" element={<AIAssistantPage />} />
        <Route path="/calendar" element={<SocialMediaCalendar />} />
        <Route path="/planner" element={<FastStartPlanner />} />
        <Route path="/playbook" element={<PlaybookLibrary />} />
        <Route path="/profile" element={<Profile />} />
        <Route 
          path="/team" 
          element={
            <ProtectedRoute roles={['Admin', 'Regional_Vice_President', 'Senior_Regional_Leader']} allowTeamLeaders={true}>
              <TeamOverview />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/manage" 
          element={
            <ProtectedRoute roles={['Admin']}>
              <RoleManagement />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/approvals" 
          element={
            <ProtectedRoute roles={['Admin']} allowTeamLeaders={true}>
              <ApprovalManagement />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/tenants" 
          element={
            <ProtectedRoute roles={['Admin']}>
              <TenantManagement />
            </ProtectedRoute>
          } 
        />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
